module.exports = __webpack_public_path__ + "img/mexico.f377af7a.svg";